import { NativeSelect } from "@mui/material";


const getOptions = () => {
    return [...Array(24 * 4)].map((_, index) => {
        const hours = Math.floor(index / 4)
        const meridiemHours = hours >= 12 ? hours - 12 : hours;
        const meridiemHoursStr = meridiemHours === 0 ? '12' : `${meridiemHours < 10 ? '' : ''}${meridiemHours}`
        const hoursStr = `${hours < 10 ? '0' : ''}${hours}`

        const minutes = (index % 4) * 15
        const minutesStr = `${minutes < 10 ? '0' : ''}${minutes}`

        const meridiem = hours < 12 ? 'AM' : 'PM';

        return { value: `${meridiemHoursStr}#${minutesStr}#${meridiem}`, display: `${hoursStr}:${minutesStr}` }
    })
}

interface Props {
    value: string;
    onChange: (event: any) => unknown;
}


const TimePicker = ({ value, onChange }: Props) => {
    return (
        <NativeSelect
            value={value}
            variant="standard"
            onChange={onChange}
        >
            {getOptions()
                .map(({ value, display }) => (<option value={value} key={value}>{display}</option>))}
        </NativeSelect>
    );
};

export default TimePicker;
